


















































import { TableSortModel } from '@/types';
import Vue from 'vue';
import { FontAwesomeLayers } from '@fortawesome/vue-fontawesome';
export default Vue.extend({
  name: 'MStoreColumnSort',
  mixins: [],
  data() {
    return {
      isSortOptionsDirty: false as boolean
    };
  },
  props: {
    size: {
      type: String
    },
    fields: {
      type: Array,
      required: true
    },
    sortOptions: {
      type: Array as () => TableSortModel[],
      required: true
    }
  },
  methods: {
    updateSortItem(this: any, sortingKey: string, isSortingAscending: boolean, index: number) {
      this.$emit('update:update-sort-option', index, { sortingKey, isSortingAscending } as TableSortModel);
      this.isSortOptionsDirty = true;
    },
    resetSort(this: any) {
      this.$emit('update:reset-sorting');
      this.isSortOptionsDirty = false;
    },
    addSortOption(this: any) {
      this.$emit('update:add-sort-option');
      this.isSortOptionsDirty = true;
    },
    applySort(this: any) {
      this.$emit('update:apply-sorting');
      this.isSortOptionsDirty = false;
    },
    deleteSortOption(this: any, index: number) {
      this.$emit('update:delete-sort-option', index);
      if (this.sortOptions.length === 0) {
        this.resetSort();
      } else {
        this.isSortOptionsDirty = true;
      }
    },
    getSortOptions(this: any, sortKey: string) {
      const allSortOptions = this.fields as TableSortModel[];
      const usedSortKeys = (this.sortOptions as TableSortModel[]).map((x) => x.sortingKey);
      const availableSortKeys = allSortOptions.map((x: any) => x.key).filter((x) => !usedSortKeys.includes(x));
      return [this.DEFAULT_SORT_OPTION, ...allSortOptions.filter((option: any) => [sortKey, ...availableSortKeys].includes(option.key))];
    }
  },
  computed: {
    hasSort() {
      return Boolean(this.sortOptions?.length);
    },
    sortsArePopulated() {
      return (this.sortOptions as TableSortModel[]).every((sort) => sort.sortingKey);
    }
  },
  created(this: any) {
    this.DEFAULT_SORT_OPTION = { key: '', label: 'Select Field', disabled: true };
  },
  components: { FontAwesomeLayers }
});
